import CryptoJS from 'crypto-js';
import axios from 'axios';
import OpenEntriesRowData from './OpenEntriesRowData';
import { setRowData  } from '../reducer/OpenentrySlice';
import MenuItem from './MenuItem';
import monthNames from './MonthNames';
import { loadFavicon, resetFavicon } from './Favicon';

export const REST_API_BASE_URL = process.env.REACT_APP_REST_API_BASE_URL;
export const defaultHome = "/home"

export function getIv() {
  return CryptoJS.lib.WordArray.random(16);
}

export function encryption(text, iv) {
  var data = text;
  var key = CryptoJS.enc.Latin1.parse(process.env.REACT_APP_API_KEY);
  var encrypted = CryptoJS.AES.encrypt(
    data,
    key,
    {
      iv:iv,mode:CryptoJS.mode.CBC,padding:CryptoJS.pad.ZeroPadding
    }
  );

  return encrypted.toString();
}

function readOpenEntryData(value, rowData) {
  const row = new OpenEntriesRowData(value);
  rowData.push(row);
}

function storeGridData(rows, dispatch) {
  let rowReformatted = [];
  rows.forEach(element => readOpenEntryData(element, rowReformatted));
  const plainData = rowReformatted.map((entry) => ({ ...entry })); 
  console.log(plainData);
  dispatch(setRowData(plainData));
}

export function isDataAvailable(obj) {
  const arr = Object.keys(obj);
  let result = false;

  arr.forEach((key) => {
    if(obj[key][0] && obj[key][0].length > 0) {
      // console.log(obj[key]);
      result = true;
    }
  })
  
  return result;
}

export async function getOpenentriesData(dispatch, info, token, setGridVisible, setNoDataMsg, navigate) {
  try {
      const response = await wrapperCall('new/readopenentries', info, token, 'json', navigate);
      const length = response.data.length;
      let dataAvailable = true;

      if(length === 1) {
        dataAvailable = isDataAvailable(response.data[0]);
      } 
      
      if(dataAvailable) {
        storeGridData(response.data, dispatch);
        setGridVisible(true);
        setNoDataMsg(false);
      } else {
        setNoDataMsg(true);
        setGridVisible(false);
      }
  } catch (error) {
      console.log(error);
  } 
}

function readCustomerEntry(value, customerData) {
  const customerEntry = new MenuItem(value['partnerCode'], value['partnerCode'] + ' - ' + value['partnerName']);
  customerData.push(customerEntry);
}

function storeCustomerEntries(rows, setCustomerList) {
  let customerEntries = [];
  rows.forEach(element => readCustomerEntry(element, customerEntries));
  const plainData = customerEntries.map((entry) => ({ ...entry })); 
  setCustomerList(plainData);
}

export async function getCustomerEntries(token, setCustomerList, navigate) {
  try {
    const response = await wrapperCall('new/readcustomer', null, token, 'json', navigate);
    storeCustomerEntries(response.data, setCustomerList);
  } catch (error) {
    console.log(error);
  } 
}

function checkLeapYear(year) {
  let leapYear = false;

  leapYear = (year % 4 === 0) && (year % 100 !== 0);
  leapYear = leapYear || (year % 400 === 0);

  return leapYear;
}

function generateMonths() {
  const date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  let months = [];

  for(let i=0; i<19; i++) {

    if(month === 0) {
      month = 12;
      year--;
      day = 31;
    } else if(month === 2) {
      const leapYear = checkLeapYear(year);
      day = (leapYear)? 29 : 28;
    } else {
      if((month % 2 === 1  &&  month < 8)  ||  (month % 2 === 0  &&  month >= 8)) {
        day = 31;
      } else {
        day = 30;
      }
    }

    const monthString = (month < 10)? "0" + month : month;
    months.push({ date: year + "-" + monthString + "-" + day, month: month, year: year});
    month--;
  }

  return months;
}

function readMonthList(value, monthList) {
  const monthEntry = new MenuItem(value['date'], monthNames[value['month']-1] + ", " + value['year']);
  monthList.push(monthEntry);
}

function storeMonthList(months, setMonthList) {
  let monthList = [];
  months.forEach(element => readMonthList(element, monthList));
  const plainData = monthList.map((entry, index) => {
    if(index === 0) {
      return ({value: entry['value'], data: "Current Month"})
    } else {
      return ({ ...entry })
    }});
  setMonthList(plainData);
}

export function getMonthList(setMonthList) {
  const months = generateMonths();
  storeMonthList(months, setMonthList);
}

export function getInfo() {
  return ({ customerID: localStorage.getItem('customerID'), 
    monthEndDate: localStorage.getItem('monthEndDate'),
    outputFormat: localStorage.getItem('outputFormat')
  })
}

export function findSequence(buffer, sequence, startIndex = 0) {
  for (let i = startIndex; i <= buffer.length - sequence.length; i++) {
      let match = true;
      for (let j = 0; j < sequence.length; j++) {
          if (buffer[i + j] !== sequence[j]) {
              match = false;
              break;
          }
      }
      if (match) return i;
  }
  return -1;
}

export function extractName(username) {
  let name = username.split('@')[0].split('.');
  let firstName = name[0];
  let lastName = (name.length === 2)? name[1] : "";
  
  let fullName = firstName.substr(0, 1).toUpperCase() + firstName.substr(1);
  if(lastName.length > 0) {
    lastName = lastName.substr(0, 1).toUpperCase() + lastName.substr(1);
    fullName += " " + lastName; 
  }

  localStorage.setItem("username", fullName);
}

export function extractInitials(username) {
  let name = username.split('@')[0].split('.');
  let firstName = name[0];
  let lastName = (name.length === 2)? name[1] : "";
  
  let initials = firstName.substr(0, 1).toUpperCase()
  if(lastName.length > 0) {
    initials += lastName.substr(0, 1).toUpperCase();
  }

  localStorage.setItem("initials", initials);
}

export function getUsername() {
  return localStorage.getItem("username");
}

export function getInitials() {
  return localStorage.getItem("initials");
}

export function getInitialState() {
  return {
    statement: false,
    buySellReport: false,
    exportToExcel: false,
    exportAllInvoices: false
  }
}

export function getInitialCriteria() {
  return {
    upperCase: 0,
    lowerCase: 0,
    numeric: 0,
    specialCharacter: 0,
    length: 0
  }
}

export function getRegistrationData() {
  return {
    email: "",
    username: "",
    newPassword: "",
    confirmPassword: "",
    key: ""
  }
}

export async function wrapperCall(endpoint, info, token, responseType, navigate) {
  let response;

  try {
      loadFavicon();
      response = await axios.post(REST_API_BASE_URL + endpoint, info, {
          responseType: responseType,
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token['accessToken']}`,
              'ApiKey': `${token['secret']}`
          }
      });
  } catch (error) {
      console.log(error);
      console.log("Error Status: " + error.status);
      let message;
      
      if(error.code === "ERR_NETWORK") {
        message = "Server side error, please try again later or contact admin.";
      } else if(error.status === 401) {
        message = "Your session is timed out, please login again to continue.";
      }

      localStorage.setItem("errorMessage", message);
      navigate("/error");
  } finally {
      resetFavicon();
      return response;
  }
}

// navigate("/error", { state: { errorMessage: message } });